export function DuoAccount({ id, name } = {}) {
  this.id = id;
  this.name = name;

  return this;
}

export function DuoApplication(data = {}) {
  this.apiHost = data.apiHost;
  this.integrationKey = data.integrationKey;
  this.name = data.name || 'User Portal';

  if (data.secretKey) {
    this.secretKey = data.secretKey;
  }

  if (data.id) {
    this.id = data.id;
  }

  return this;
}

export function UserPortalDuoConfig(data = { enabled: false }) {
  this.enabled = (data.enabled === true) || false;

  if (data.id) {
    this.id = data.id;
  }

  return this;
}
